module.exports = __webpack_public_path__ + "img/bo.bb0f25c2.svg";